import axios from "./axios"

function index(search) {
    return axios().get("/taxes-search", {
        params: {
            search
        }
    });
}

export default {
    index
}